<template>
  <div class="loading-screen" v-if="store.getters.loading">
    <HighlightScreen :username="store.getters.name" scene="details" />
  </div>
  <div class="cart-button-div">
    <button
      class="cart-button"
      id="checkoutButtonMobile"
      v-if="!store.getters.disableCheckout"
      :class="['button']"
      @click="addToCart()"
    >
      <div class="dot-pulse" v-if="store.getters.loading"></div>
      <span v-else>{{ buttonCheckout }}</span>
    </button>
  </div>
</template>

<script setup>
import store from "@/store/store";
import { defineProps } from "vue";
import HighlightScreen from "./HighlightScreen.vue";

const props = defineProps({
  buttonCheckout: String,
  i18n: Object,
});

const addToCart = () => {
  if (store.getters.loading || !store.getters?.personalMix?.length) return;

  store.dispatch("addToCart", {
    ctx: {
      $i18n: props.i18n,
    },
    options: {
      reorder: props.reorder,
      monthly: props.monthly,
      isBloodTestChecked: props.isBloodTestChecked,
      price: props.price,
      monthlyPrice: props.monthlyPrice,
      months: props.months,
      reorderMonths: props.reorderMonths,
      discount: props.discount,
    },
  });
};
</script>

<style>
.cart-button-div {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.cart-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  flex: 1;
  margin-right: 0 !important;
  font-size: 20px;
}

.loading-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 90%;
  background-color: #683af2;
  z-index: 9999;
  overflow: hidden;
  padding-top: 80px;
}
</style>
